var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7205 1.91162C6.12054 1.91162 2.38721 5.64495 2.38721 10.245C2.38721 14.845 6.12054 18.5783 10.7205 18.5783C15.3205 18.5783 19.0539 14.845 19.0539 10.245C19.0539 5.64495 15.3205 1.91162 10.7205 1.91162ZM14.8872 11.0783H11.5539V14.4116H9.88721V11.0783H6.55387V9.41162H9.88721V6.07829H11.5539V9.41162H14.8872V11.0783Z",
    fill: "#77787A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandGray);
export default __webpack_public_path__ + "static/media/expandGray.257ba885c68a5961064de2c0d146287d.svg";
export { ForwardRef as ReactComponent };